import { BillingDataService } from './../data-services/billing-data.service';
import { UserDetailsService } from './user-details.service';
import { StorageServiceObservablesService } from './../storage-service-observables/storage-service-observables.service';
import { BankAccountService } from './bank-account.service';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { PaperlessService } from '../_iam/paperless.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileConfirmModalService {
  public hideModalOnRoute = false;
  private checkDirty = new BehaviorSubject<boolean>(false);
  $checkDirty = this.checkDirty.asObservable();
  private removeAccount = new BehaviorSubject<boolean>(false);
  $removeAccount = this.removeAccount.asObservable();
  previousURL: any;

  constructor(
    public router: Router,
    private bankAccountService: BankAccountService,
    private storageService: StorageServiceObservablesService,
    private userDetailsService: UserDetailsService,
    private paperlessService: PaperlessService,
    private billingDataService: BillingDataService
  ) {}

  onCheckDirty(inputForm: FormGroup) {
    if (inputForm.dirty) {
      this.checkDirty.next(true);
    } else {
      this.checkDirty.next(false);
    }
  }

  updateCheckDitry(value: boolean) {
    this.checkDirty.next(value);
  }

  onRemoveCheckingAccount(removeAccount: string, policyId?, bankAccount?) {
    this.removeAccount.next(false);
    this.hideModalOnRoute = !this.hideModalOnRoute;
    if (removeAccount === 'remove') {
      this.bankAccountService
        .deleteBankAccount(this.storageService.getUserFromStorage(), policyId)
        .subscribe(
          () => {
            this.billingDataService.clearCheckingAccount();
            this.userDetailsService.getUserDetailsByEmail().subscribe(() => {
              this.router.navigate([`/profile/delete-payment-inst-success`], {
                state: { bankAccount: `${bankAccount}` },
              });
            });
          },
          () =>
            this.router.navigate([`/profile/delete-payment-inst-error`], {
              state: { bankAccount: `${bankAccount}`, policyId: `${policyId}` },
            })
        );
    }
    return this.hideModalOnRoute;
  }

  onClickBack(onclick: string) {
    this.previousURL = this.paperlessService.getCurrentRoute();

    if (onclick === 'back') {
      if (this.previousURL === '/billing/paperless') {
        this.router.navigate(['/billing/paperless']);
      } else {
        this.router.navigate(['/profile']);
      }
    } else {
      this.checkDirty.next(false);
      this.hideModalOnRoute = !this.hideModalOnRoute;
      return this.hideModalOnRoute;
    }
  }

  onRestoreDefault() {
    this.checkDirty.next(false);
    this.removeAccount.next(false);
  }

  resetRemoveAccount() {
    this.removeAccount.next(false);
  }
}
